<template>
  <div class="pbl-container">
    <div class="banner">
      <img class="img" :src="$env.imgUrl + (activeIndex === 0 ? 'banner-pbl.png' : 'banner-pbl2.png')" alt="">
      <div class="banner-content">
        <div class="banner-title">全球青少年PBL创新挑战赛</div>
        <div class="banner-title-en">PBL Innovation Challenge</div>
        <div class="banner-tab">
          <div class="banner-tab-item" :class="activeIndex === index ? 'sel' : ''" v-for="(item, index) in tabs" :key="index" @click="handleTabClick(index)">
            <div class="cn">{{ item.title }}</div>
            <div class="en">{{ item.enTitle }}</div>
          </div>
        </div>
      </div>
    </div>
    <pbl1 v-if="activeIndex === 0"></pbl1>
    <pbl2 v-if="activeIndex === 1"></pbl2>
    <pbl3 v-if="activeIndex === 2"></pbl3>
    <pbl4 v-if="activeIndex === 3"></pbl4>
  </div>
</template>
<script>
import pbl1 from './pbl/pbl1.vue'
import pbl2 from './pbl/pbl2.vue'
import pbl3 from './pbl/pbl3.vue'
import pbl4 from './pbl/pbl4.vue'
export default {
  components: {
    pbl1, pbl2, pbl3, pbl4
  },
  data () {
    return {
      activeIndex: 0,
      tabs: [
        {
          title: '2026四大领域',
          enTitle: '2026 Four Key Areas '
        },
        {
          title: '赛事完整概况',
          enTitle: 'Full Competition Overview'
        },
        {
          title: '战队注册体系',
          enTitle: 'Team Registration System'
        },
        {
          title: '专业评审体系',
          enTitle: 'Professional Judge System'
        }
      ]
    }
  },
  created() {
    this.activeIndex = this.$route.query.index ? Number(this.$route.query.index) : 0
    this.$store.dispatch('SET_MENUINDEX', 2)
  },
  watch: {
    '$route' (to) {
      this.activeIndex = to.query.index ? Number(to.query.index) : 0
    }
  },
  methods: {
    handleTabClick (index) {
      this.activeIndex = index
      this.$router.replace({ query: { index } })
    }
  }
}
</script>
<style scoped lang="less">
.pbl-container{
  width: 100vw;
  overflow: hidden;
}
.banner{
  width: 100vw;
  position: relative;
  min-height: 300px;
  .img{
    width: 100%;
    height: auto;
    display: block;
  }
  .banner-content{
    position: absolute;
    top: 250px;
    left: 0;
    right: 0;
    text-align: center;
  }
  .banner-title{
    color: #fff;
    font-family: regular;
    font-size: 58px;
    margin-bottom: 10px;
  }
  .banner-title-en{
    color: #fff;
    font-family: alim;
    font-size: 18px;
  }
  .banner-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    .banner-tab-item{
      margin: 20px 10px;
      width: 240px;
      height: 46px;
      border-radius: 46px;
      text-align: center;
      background-color: #fff;
      color: #000;
      cursor: pointer;
      padding-top: 8px;

      .cn{
        font-family: systh;
        font-size: 16px;
        line-height: 20px;
      }
      .en{
        font-family: systm;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }
  .sel{
    background-color: #C92739 !important;
    color: #FFF !important;
  }
}
</style>
